"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _utils = require("../../utils");

var styles = {
  "container": "styles-container-2d0MF",
  "fixed": "styles-fixed-3La6G",
  "item": "styles-item-1WhX8",
  "brand": "styles-brand-1otuI"
};

var Item = function Item(_ref) {
  var children = _ref.children,
      className = _ref.className,
      _ref$tag = _ref.tag,
      Tag = _ref$tag === void 0 ? 'div' : _ref$tag,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, ["children", "className", "tag"]);
  return /*#__PURE__*/_react["default"].createElement(Tag, (0, _extends2["default"])({
    className: _utils.classNames.use('item').from(styles).join(className)
  }, restProps), children);
};

Item.displayName = "Item";
var _default = Item;
exports["default"] = _default;